<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >
        <el-form-item
          label="广告位"
          required
          prop="advertisement_position_slug"
        >
          <el-select
            v-model="form.advertisement_position_slug"
            clearable
            :disabled="footerDisabled"
            @change="advertisementPositionChange"
            placeholder="选择广告位"
          >
            <el-option
              v-for="i in advertisement_positions"
              :key="i.id"
              :label="i.name"
              :value="i.slug"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="广告类型" required prop="type">
          <el-select
            v-model="form.type"
            clearable
            @change="adChange"
            :disabled="adChangeDisabled"
            placeholder="选择广告类型"
          >
            <el-option
              v-for="(i,key) in types"
              :key="key"
              :label="i.name"
              :value="i.slug"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="广告名称" required prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="广告层级" required prop="name">
          <el-input placeholder="请输入数字，数字越大越靠前" v-model="form.sort" onkeyup="this.value=this.value.replace(/[^\d]/g,'');"/>
        </el-form-item>
        <el-form-item label="缩略内容" required prop="surface">
          <el-upload
            class="avatar-uploader"
            action="/admin-api/advertisements/uploadImg"
            name="surface"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="form.surface" :src="form.surface" class="avatara">
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <!-- <el-input v-model="form.surface"/> -->
        </el-form-item>
        <el-form-item label="投放区域" required prop="area_id">
          <el-select
            v-model="form.area_id"
            clearable
            placeholder="选择区域"
          >
            <el-option
              v-for="i in areas"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="广告详情"
          v-show="adShowDetail"
          required
          prop="detail"
        >
          <el-input v-if="showDetail==1" placeholder="请输入链接，必须带https或小程序内路径,或者手机号,或腾讯广告id,跳转appid"
                    v-model="form.detail"/>
          <Editor v-else-if="showDetail==2" :value="form.detail" @input="handelIncrease"/>
          <span v-else-if="showDetail==3"/>
        </el-form-item>
        <el-form-item label="投放状态" required prop="is_display">
          <el-radio v-model="form.is_display" label="0">未投放</el-radio>
          <el-radio v-model="form.is_display" label="1">已投放</el-radio>
        </el-form-item>
        <el-form-item label="投放开始时间" required prop="start_time">
          <el-date-picker
            v-model="form.start_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="投放结束时间" required prop="end_time">
          <el-date-picker
            v-model="form.end_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { getAdvertisementSelectData, storeAdvertisement, editAdvertisement, updateAdvertisement } from '@/api/advertisement'
import { getAreas } from '@/api/area'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import { getToken } from '@/libs/token'
import Editor from '@c/Editor'

export default {
  name: 'Form',
  components: {
    LzForm,
    Editor,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        advertisement_position_slug: '',
        type: 'clilk_null',
        name: '',
        surface: '',
        area_id: '',
        detail: '',
        is_display: '1',
        start_time: '',
        end_time: '',
        sort: '',
      },
      errors: {},
      areas: [],
      advertisement_positions: [],
      types: [],
      uploadHeaders: {
        Authorization: '',
      },
      showDetail: '',
      adChangeDisabled: false, // 广告类型是否可选
      adShowDetail: false, // 广告详情是否展示
      footerDisabled: false,
    }
  },
  created() {
    this.uploadHeaders.Authorization = getToken()
  },
  methods: {
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])
      const [
        { data: selectData },
      ] = await Promise.all([
        getAdvertisementSelectData(),
      ])

      this.areas = [{ id: 0, name: '全部' }]
      areas.map(i => {
        this.areas.push({ id: i.id, name: i.name })
      })
      this.types = selectData.advertisementType
      this.advertisement_positions = selectData.advertisementPosition

      console.log(this.editMode)
      if (this.editMode) {
        const { data } = await editAdvertisement(this.resourceId)
        data.is_display = data.is_display ? '1' : '0'
          if (data.type == 'url' || data.type == 'wxUrl' || data.type == 'phone' || data.type == 'wxTencentAdvertisement' || data.type == 'wxTencentIncentiveAdvertisement' || data.type == 'wxTencentAdvertisementVideo' || data.type == 'toMiniProgram') {
              this.showDetail = 1
              this.adShowDetail = true
          } else if (data.type == 'text') {
              this.showDetail = 2
              this.adShowDetail = true
          } else {
              this.showDetail = 1
              this.adShowDetail = false
          }
        console.log(this.footerDisabled)
        this.footerDisabled = true
        this.fillForm(data)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateAdvertisement(this.resourceId, this.form)
      } else {
        await storeAdvertisement(this.form)
      }
    },
    adChange() {
      // console.log(this.form.type)
        if (this.form.type == 'url' || this.form.type == 'wxUrl' || this.form.type == 'phone' || this.form.type == 'wxTencentAdvertisement' || this.form.type == 'wxTencentIncentiveAdvertisement' || this.form.type == 'wxTencentAdvertisementVideo' || this.form.type == 'toMiniProgram') {
            this.showDetail = 1
            this.adShowDetail = true
        } else if (this.form.type == 'text') {
            this.showDetail = 2
            this.adShowDetail = true
        } else {
            this.showDetail = 1
            this.adShowDetail = false
        }
    },
    advertisementPositionChange() {
        // if (this.form.advertisement_position_slug == 'footer') {
        //   this.form.type = 'clilk_null'
        //   this.adChangeDisabled = true
        // } else {
        this.adChangeDisabled = false
        // }
    },
    handleAvatarSuccess(res, file) {
      this.form.surface = res.path
      // console.log(res)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    handelIncrease(step) {
      // console.log('step', step)
      this.form.detail = step
    },
  },
}
</script>
<style lang="scss" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatara {
     /* width: 178px; */
    height: 178px;
    display: block;
  }
</style>
